import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
  MatBottomSheet,
} from '@angular/material/bottom-sheet';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { ContactAccountDto } from 'src/app/domain/models/dto/contact-account.dto';
import { AddBankAccountComponent } from 'src/app/pages/account/modals/add-bank-account/add-bank-account.component';
import { RemoveContactConfirmComponent } from '../remove-contact-confirm/remove-contact-confirm.component';
import { AddContactComponent } from '../add-contact/add-contact.component';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
})
export class ContactDetailsComponent implements OnInit {
  isMobile = false;
  moedas = Moedas;
  boobleModalData: ContactAccountDto;
  currency: any;

  constructor(
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private dataBottomSheet,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<AddBankAccountComponent>,
    private bottomSheet: MatBottomSheet,
    private modalService: BoobleModalService
  ) {}

  ngOnInit() {
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData.currency.id
    );
    this.isMobile = window.innerWidth <= 820 ? true : false;

    if (this.isMobile) {
      this.boobleModalData = this.dataBottomSheet;
    }
  }
  openRemoveContactModal(contactId: number) {
    this.modalService.present(RemoveContactConfirmComponent, contactId);
  }
  openAddContactModal(data: any) {
    this.modalService.present(AddContactComponent, data);
  }

  closeModal() {
    if (this.isMobile) {
      this.bottomSheet.dismiss();
    } else {
      this.modalService.dismiss(null);
    }
  }
}
